import Isotope from "isotope-layout"
import imagesLoaded from "imagesloaded"

class isotopeModule
{
    static run () {

        window.imagesLoaded = imagesLoaded;
        const togglesIso = document.querySelectorAll('[data-isotope]');
        const filters = document.querySelectorAll('[data-filter]');

        togglesIso.forEach(function (toggle) {
            imagesLoaded(toggle, function () {
                const options = JSON.parse(toggle.dataset.isotope);
                new Isotope(toggle, options);
            });
        });

        filters.forEach(function (filter) {
            filter.addEventListener('click', function (e) {
                e.preventDefault();

                const cat = filter.dataset.filter;
                const target = filter.dataset.bsTarget;
                const instance = Isotope.data(target);

                instance.arrange({
                    filter: cat,
                });
            });
        });

    }
}

export default isotopeModule;
